
import { Component, Mixins, Watch, PropSync, Prop } from 'vue-property-decorator';
import { VuetifyMixin, BAIconsMixin, StringsMixin } from '@/mixins';
import { AthleteProfileModel } from '@/models/athlete/AthleteProfileModel';
import { athleteApi } from '@/api/AthleteApi';
import { DebounceMixin } from '@/mixins';
import { QueryOptions, RepositoryQuery } from '@/../types';

@Component
export default class AdminAthleteAutocomplete extends Mixins(DebounceMixin, VuetifyMixin, BAIconsMixin, StringsMixin){
	@PropSync('value') athlete: AthleteProfileModel | null;
	@Prop({ default: "Select Athlete" }) label: string;
	@Prop({ default: "Start typing to search" }) placeholder: string;
	@Prop({ default: 10 }) limit: number;
	@Prop({ type: String }) search: string = "";
	@Prop({ type: Boolean }) loading;
	@Prop({ type: Boolean }) disabled;
	@Prop({ default: 20 }) avatarSize: number;
	@Prop({ type: Boolean }) showId;
	@Prop({ type: Boolean }) showDeleted;
	@Prop() sportId: string;

	athletes: Array<AthleteProfileModel> = [];
	numAthletes: number = 0;

	searchLoading: boolean = false;
	@Watch('search') debounceSearchAthletes(): void{
		this.searchLoading = true;
		this.debounceCallback('searchAthletes', this.searchAthletes.bind(this), 500);
	}

	onValueChanged(newVal) {
		this.$emit('athleteChange', newVal);
	}
	async searchAthletes(): Promise<void>{
		this.searchLoading = true;
		try {
			const query: RepositoryQuery<AthleteProfileModel> = {
				search: this.search,
				fields: [
					'id',
					'firstName',
					'lastName',
					'email',
					'tags',
				]
			}
			query.$match = {...query.$match, ...{ deleted: this.showDeleted? true : {$any:[false, undefined, null]} }};
			if( this.IsNotEmpty(this.sportId) ) query.$match = {...query.$match, ...{ athleteSports: this.sportId }};
			const options: QueryOptions = {limitPerPage: this.limit};
			const response = await athleteApi.queryAll(query, options);
			this.numAthletes = response.total;
			this.athletes = response.docs.map(d => new AthleteProfileModel().load(d));
		} catch(e) {
			console.error('Failed to query athletes', e);
		}

		this.searchLoading = false;
	}
}
